export default __webpack_public_path__ + "static/media/belt_of_the_forsaken.0bfbae90.jpg";